import { ComparisonModes } from '@/entities/market-intel/model/types';
import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import { responseContract } from '../../lib';

const _GetAlertsResolutionEffectivenessRequestDtoSchema = z.object({
  facilityId: z.number(),
  comparisonSet: z.enum(ComparisonModes),
  from: z.string(),
  to: z.string(),
});

const GetAlertsResolutionEffectivenessResponseDtoSchema = z.object({
  currentValue: z.number().nullable(),
  hint: z.string(),
  marketMedian: z.number().nullable(),
  message: z.string(),
});

export type GetAlertsResolutionEffectivenessRequestDto = z.infer<
  typeof _GetAlertsResolutionEffectivenessRequestDtoSchema
>;
export type GetAlertsResolutionEffectivenessResponseDto = z.infer<
  typeof GetAlertsResolutionEffectivenessResponseDtoSchema
>;

export const getAlertsResolutionEffectiveness = (
  params: GetAlertsResolutionEffectivenessRequestDto,
  config?: AxiosRequestConfig<GetAlertsResolutionEffectivenessRequestDto>
) => {
  const { facilityId, ...queryParams } = params;

  return api
    .get(
      `/market-intelligence/facilities/${facilityId}/alerts-resolution-effectiveness`,
      {
        params: queryParams,
        ...config,
      }
    )
    .then(responseContract(GetAlertsResolutionEffectivenessResponseDtoSchema));
};
